angular.module('unica_invitation_room.invitation_room_controllers')

.controller('InvitationRoomEditController', function(
	$rootScope, $scope, $state, $stateParams,
	InvitationRoomEditService
) {
	$scope.event_id = $stateParams.event_id;

	$rootScope.getEvent( $stateParams.event_id );

	$rootScope.getInvitationRoom( $stateParams.id );

	$scope.$on('invitation_room_loaded', function() {
		$rootScope.getRoomList( $stateParams.event_id, $rootScope.invitationRoomData.room_id );
	});

	$rootScope.getInvitationsByEvent( $stateParams.event_id );



	$rootScope.invitationRoomData = {
		event_id: $stateParams.event_id
	};

	$scope.saveInvitationRoom = function() {
		$scope.showLoader();

		InvitationRoomEditService
			.update( $rootScope.invitationRoomData )
			.then(function(data) {
				$scope.hideLoader();

				if (!data.error) {
					$scope.showSuccessMsg('Aggiornamento Assegnazione Stanza avvenuta con successo!', '');
				} else {
					$rootScope.manageError(data);
				}
			});
	};

});
